import { render, staticRenderFns } from "./LongTermMakeUp.vue?vue&type=template&id=a804b06c&scoped=true&"
import script from "./LongTermMakeUp.vue?vue&type=script&lang=js&"
export * from "./LongTermMakeUp.vue?vue&type=script&lang=js&"
import style0 from "./LongTermMakeUp.vue?vue&type=style&index=0&id=a804b06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a804b06c",
  null
  
)

export default component.exports